import axios from "axios";

export const getResults = async (word, limit) => {
  const data = axios.get(
    `${process.env.CONTENTLOAN_API_URL}/search/api/v1/predictive?limit=${limit}&word=${word}`
  );
  return data;
};
